import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "../thema/style";
import AddCartButton from "./AddCartButton";
import { Link } from "react-router-dom";
import { PUBLIC_URL } from "../config";

class ProductItem extends Component {
  constructor(props) {
    super(props);
    this.img = React.createRef();
  }

  render() {
    return (
      <div className={this.props.itemSize}>
        <div className={styles.productItem}>
          <div ref={this.thumb} className={"product-thumb"}>
            <div className={"product-thumb-detail"}>
              <Link
                to={{
                  pathname: `/urun/${this.props.slug}`,
                  state: { product: this.props }
                }}
              >
                <span>
                  <FontAwesomeIcon icon={["fas", "search"]} color={"#fff"} />
                </span>
              </Link>
            </div>
            <img
              alt={this.props.name}
              ref={this.img}
              src={PUBLIC_URL(this.props.image)}
            />
          </div>
          <div className={"product-info"}>
            <Link
              to={{
                pathname: `/urun/${this.props.slug}`,
                state: { product: this.props }
              }}
            >
              <h3 className={"product-title"}>{this.props.name}</h3>
            </Link>
            <div className={"product-price"}>
              {this.props.sale_price ? (
                <React.Fragment>
                  <span className={"old-price"}>₺{this.props.price}</span>
                  <span className={"special-price"}>
                    ₺{this.props.sale_price}
                  </span>
                </React.Fragment>
              ) : (
                <span className={"special-price"}>₺{this.props.price}</span>
              )}
            </div>
            <div className={"product-extra-link"}>
              <AddCartButton img={this.img} product={this.props} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ProductItem.defaultProps = {
  itemSize: "col-md-3"
};

export default ProductItem;
// const mapStateToProps = ({}) => {
//   return {};
// };
//
// const mapDispatchToProps = { setProduct };
//
// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(ProductItem);



// WEBPACK FOOTER //
// ./src/components/ProductItem.js